import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { isBrowser } from 'Helpers/Browser';

import Spinner from 'Components/layout/Spinner';

export default class CartPackagesPanel extends React.Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        onSelect: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        selectedPackageId: PropTypes.string,
        visible: PropTypes.bool.isRequired,
        items: PropTypes.array.isRequired,
        packages: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                price: PropTypes.number.isRequired,
                credits: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                worthPhotos: PropTypes.number.isRequired,
                discountPercentage: PropTypes.number.isRequired
            })
        )
    };
    static defaultProps = {
        isLoading: false,
        selectedPackageId: ''
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { isLoading, packages, items, selectedPackageId, visible } = this.props;

        if (!visible) {
            return null;
        }

        if (isLoading) {
            return (
                <div className="component-cart-packages-panel">
                    <Spinner className="relative" />
                </div>
            );
        } else {
            return (
                <div className="component-cart-packages-panel">
                    <h5 className="packages-headline">Save money, select a credit package:</h5>
                    {packages.length ?
                        <div className="packages-list">
                            {
                                packages.map(creditPackage => {

                                    //Don't show package if worth photos is lower than items in cart
                                    if (items.length > creditPackage.worthPhotos) {
                                        return null;
                                    }

                                    return (
                                        <div
                                            id={creditPackage.id}
                                            className={`packages-list-element ${selectedPackageId === creditPackage.id ? 'selected' : ''}`}
                                            key={creditPackage.id}
                                            onClick={() => this.props.onSelect(creditPackage)}
                                        >
                                            <div className="packages-list-element-col packages-list-element-col-left">
                                                <span className="radio-button">
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>
                                            <div className="packages-list-element-col packages-list-element-col-middle">
                                                <p className="package-credits">{creditPackage.credits} Credits</p>
                                                <p className="package-worth">{creditPackage.worthPhotos} Photos with <span className="disount-text">{creditPackage.discountPercentage}% discount</span></p>
                                            </div>
                                            <div className="packages-list-element-col packages-list-element-col-right">
                                                <p className="package-price"><small>$</small>{creditPackage.price.toFixed(2)}</p>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        : null}
                </div>
            );
        }

    }
}



// WEBPACK FOOTER //
// ./src/components/public/cart/PackagesPanel/index.js